/* eslint-disable camelcase */
export default ({ item_name, item_qty, fulfillment_status }) => ({
  itemDescription: item_name,
  itemQuantity: item_qty,
  itemReturned: !!fulfillment_status,
});
